import request from '@/api/request'

/**
 * 查询活动信息
 * @param activityType newCustomer
 * @returns
 */
export const fetchGetActivity = async (
  activityType: string,
): Promise<DataResponse<any>> => {
  return await request.get(`/saas-insurance/activity/get/${activityType}`)
}

/**
 * 查询活动弹框
 * @param activityId
 * @returns
 */
export const fetchQueryActivity = async (
  activityId: string,
): Promise<DataResponse<any>> => {
  return await request.get(`/saas-insurance/activity/jump/${activityId}`)
}

/**
 *
 * @param activityId
 * @param noticeType 0：活动通知弹框，1：活动参与成功通知弹框
 * @returns
 */
export const fetchActivityIkonw = async (data: {
  activityId: string
  noticeType: number
}): Promise<DataResponse<any>> => {
  return await request.post(`/saas-insurance/activity/i-know`, data)
}
